/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonsmissingphone3Inputs */

const en_listingbuttonsmissingphone3 = /** @type {(inputs: Listingbuttonsmissingphone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No phone number –`)
};

const de_listingbuttonsmissingphone3 = /** @type {(inputs: Listingbuttonsmissingphone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Telefonnummer –`)
};

/**
* | output |
* | --- |
* | "No phone number –" |
*
* @param {Listingbuttonsmissingphone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonsmissingphone3 = /** @type {((inputs?: Listingbuttonsmissingphone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonsmissingphone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonsmissingphone3(inputs)
	return de_listingbuttonsmissingphone3(inputs)
});
export { listingbuttonsmissingphone3 as "listingButtonsMissingPhone" }